import { NumberField } from '@e3dc-react/shell/Elements/InputFields'
import { Box, Stack, Typography as MuiTypography } from '@mui/material'
import React from 'react'
import ChargingSlider from '../ChargingSlider'
import { makeStyles } from 'tss-react/mui'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useFormContext, useWatch } from 'react-hook-form'
import { ChargingScheduleFormFieldNames, ChargingScheduleFormType } from 'src/Libs/e-mobility/vehicle-integration'
import { UnitTypes } from 'src/Libs/types'

const useStyles = makeStyles()(theme => ({
  numberField: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
    },
  },
}))

const MIN = 0
const MAX = 100

interface Props {
  minStateOfCharge: number | null
  chargeLimitMax?: number
}

/**
 * Slider part for the schedule form
 */
const ScheduleSlider: React.FC<Props> = ({ minStateOfCharge, chargeLimitMax }) => {
  const { classes } = useStyles()
  const { control, setValue } = useFormContext<ChargingScheduleFormType>()
  const targetStateOfCharge = useWatch({ control, name: ChargingScheduleFormFieldNames.TargetStateOfCharge })

  const isMinSocHigher = minStateOfCharge !== null && targetStateOfCharge !== null && minStateOfCharge > targetStateOfCharge
  const isSocHigherThanMax = chargeLimitMax && targetStateOfCharge && targetStateOfCharge > chargeLimitMax

  return (
    <Box>
      <Stack gap={2}>
        <Stack gap={2} direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ flex: 1 }} variant="h3">
            emobility.vehicle-integration.state-of-charge.set-charge-goal
          </Typography>
          <Box sx={{ flex: 1 }}>
            <NumberField
              className={classes.numberField}
              value={targetStateOfCharge ?? 0}
              onChange={value => setValue(ChargingScheduleFormFieldNames.TargetStateOfCharge, value === '' ? 0 : value)}
              min={MIN}
              max={MAX}
              suffix={UnitTypes.percentage}
            />
          </Box>
        </Stack>
        <ChargingSlider
          value={targetStateOfCharge ?? 0}
          min={MIN}
          max={MAX}
          onChange={value => setValue(ChargingScheduleFormFieldNames.TargetStateOfCharge, value)}
          markerInPercentage={chargeLimitMax}
        />
        {isMinSocHigher && (
          <Typography variant="body2" values={{ generalTargetSoc: minStateOfCharge }}>
            emobility.vehicle-integration.state-of-charge.general-soc-higher-than-selected
          </Typography>
        )}
        {isSocHigherThanMax && (
          <Typography
            variant="body2"
            values={{
              value: `${chargeLimitMax} ${UnitTypes.percentage}`,
            }}
            components={{
              a: <MuiTypography variant="subtitle1" component="span" />,
            }}
          >
            {'emobility.vehicle-integration.state-of-charge.soc-more-than-max-message'}
          </Typography>
        )}
      </Stack>
    </Box>
  )
}

export default ScheduleSlider
